import styled from 'styled-components';
import { Button as AlchemyButton } from '@m/alchemy-ui/Button';

export const Container = styled.div`
  align-items: center;
  display: inline-flex;
`;

export const Button = styled(AlchemyButton)`
  border-radius: 20px;
  height: 100px;
  transform: rotateZ(45deg);
  width: 100px;
`;

export const ButtonContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  transform: rotateZ(-45deg);
  width: 100%;
`;
